import { Inject, Injectable, InjectionToken } from '@angular/core';
import { PartialIDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { IFetchConfigService } from '../fetch-config.service';

export type DictionaryEntry = [string, PartialIDynamicItem[]];

export const DYNAMIC_CONFIG_TOKEN = new InjectionToken<DictionaryEntry[][]>(
  'DynamicConfigToken',
);

@Injectable({
  providedIn: 'root',
})
export class FetchConfigFromCodeService implements IFetchConfigService {
  private readonly configDictionary: Map<string, PartialIDynamicItem[]> =
    new Map<string, PartialIDynamicItem[]>();

  constructor(
    @Inject(DYNAMIC_CONFIG_TOKEN)
    configArrays: DictionaryEntry[][],
  ) {
    for (const configArray of configArrays) {
      for (const config of configArray) {
        this.configDictionary.set(...config);
      }
    }
  }

  public canFetchFrom(source: string): boolean {
    return source.trim().toLowerCase() === 'code';
  }

  public fetch(key: string): PartialIDynamicItem[] | null {
    const config = this.configDictionary.get(key);

    if (config === undefined) {
      return null;
    }

    return config;
  }
}
